import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { ParametrosMaestro } from 'src/app/models/common/enumModel';
import { SearchResultModel } from 'src/app/models/common/SearchResultModel';
import { IFilterTipoReglaModel } from 'src/app/models/interfaces/tipo-regla/IFilterTipoReglaModel';
import { ITipoReglaModel } from 'src/app/models/interfaces/tipo-regla/ITipoReglaModel';
import { ParametroModel } from 'src/app/models/parametros/ParametroModel';
import { FilterTipoReglaModel } from 'src/app/models/tipo-regla/FilterTipoReglaModel';
import { TipoReglaModel } from 'src/app/models/tipo-regla/TipoReglaModel';
import { ParametroService } from 'src/app/services/parametros/parametro.service';
import { TipoReglaService } from 'src/app/services/tipo-regla/tipo-regla.service';

@Component({
  selector: 'app-configuracion-tipo-regla-listar',
  templateUrl: './configuracion-tipo-regla-listar.component.html',
  styleUrls: ['./configuracion-tipo-regla-listar.component.css']
})
export class ConfiguracionTipoReglaListarComponent implements OnInit {
  model!: SearchResultModel<ITipoReglaModel[]>;
  filter: IFilterTipoReglaModel = new FilterTipoReglaModel();
  listaEstados: ParametroModel[] = new Array<ParametroModel>();
  resultsLength = 0;
  currentPage = 0;

  displayedColumns: string[] = [
    'id',
    'nombre',
    'estado',
    'acciones'
  ];
  
  @ViewChild('paginator') paginator!: MatPaginator;

  constructor(
    private serviceTipoRegla: TipoReglaService,
    private serviceParametros: ParametroService
  ) { 
    this.model = new SearchResultModel<ITipoReglaModel[]>(false, new Array<TipoReglaModel>(), 0, 1, 0);
  }

  ngOnInit(): void {
    this.serviceParametros.getDetalles(ParametrosMaestro.ESTADO_CONFIG_MAESTRO).subscribe((data) => {
      this.listaEstados = data.items;
    });
    
    this.serviceTipoRegla.getListFiltered(this.filter).subscribe((data) => {
      this.model = data;
      this.resultsLength = data.total;
    });
  }

  search(): void{
    this.filter.page = 1;
    this.filter.pageSize = 30;
    this.serviceTipoRegla
      .getListFiltered(this.filter)
      .subscribe((data) => {
        this.model = data;
        this.resultsLength = data.total;
        this.currentPage = 0;
        this.paginator.firstPage();
      });
  }

  getPaginatorData(event: any) {
    this.filter.page = event.pageIndex + 1;
    this.filter.pageSize = event.pageSize;
    this.serviceTipoRegla
      .getListFiltered(this.filter)
      .subscribe((data) => {
        this.model = data;
        this.resultsLength = data.total;
      });
  }

}
